// extracted by mini-css-extract-plugin
module.exports = {"ChangePaymentMethod":"ChangePaymentMethod_yB8O-"};